import { nullishFilter } from '@caresend/utils';
import { reportException } from './sentry.js';
import { toastError } from './toast/toast.js';

/**
 * Given an array of IDs, use a predicate to find an array of elements.
 * Display a toast and/or throw an error noting which IDs were not found.
 *
 * Default behavior for missing data: Display toast and report exception without
 * throwing runtime error.
 */
const getElementsFromIDs = (ids, predicate, entityName = 'element', throws = false, reports = true, toasts = true) => {
    const missingIDs = [];
    const elements = ids.map((id) => {
        const element = predicate(id);
        if (!element)
            missingIDs.push(id);
        return element;
    }).filter(nullishFilter);
    if (missingIDs.length) {
        const missingIDsString = missingIDs.join(', ');
        const message = `Missing ${entityName}(s): ${missingIDsString}`;
        if (toasts)
            toastError(message);
        if (throws)
            throw Error(message); // Thrown errors automatically reported
        if (reports)
            reportException(message);
    }
    return elements;
};

export { getElementsFromIDs };
